export const properties=()=>{
    return  {  
        CORREOS_TO:["arizbeth.cansino@gnp.com.mx","jose.pineda@gnp.com.mx"],
        CORREOS_FROM:  "gnpautoelite@.com.mx",
        CORREO_ENDPOINT: "https://us-central1-gnp-portalcorporativo-pro.cloudfunctions.net/EnviarMail"
    }

};


/*
QA
 CORREOS_TO:["oscar.diez@gtec.com.mx","sgil@amarello.com.mx"],
        CORREOS_FROM:  "gnpautoelite@.com.mx",
        CORREO_ENDPOINT: "https://us-central1-gnp-portalcorporativo-qa.cloudfunctions.net/EnviarMail"


UAT

 CORREOS_TO:["oscar.diez@gtec.com.mx","sgil@amarello.com.mx"],
        CORREOS_FROM:  "gnpautoelite@.com.mx",
        CORREO_ENDPOINT: "https://us-central1-gnp-portalcorporativo-uat.cloudfunctions.net/EnviarMail"

PROD

 CORREOS_TO:["arizbeth.cansino@gnp.com.mx","jose.pineda@gnp.com.mx"],
        CORREOS_FROM: "gnpautoelite@.com.mx",
        CORREO_ENDPOINT: "https://us-central1-gnp-portalcorporativo-prod.cloudfunctions.net/EnviarMail"

*/


// WEBPACK FOOTER //
// ./src/properties/properties.js